import { render, staticRenderFns } from "./AssessmentClient.vue?vue&type=template&id=629d7342&"
import script from "./AssessmentClient.vue?vue&type=script&lang=js&"
export * from "./AssessmentClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports